<template>
  <div class="container-fluid">
    <div class="row my-3">
      <div class="card w-100">
        <div class="card-header d-flex justify-content-between">
          <p>Нийтлэлүүд</p>
          <router-link
            v-if="!isBannerMgr"
            :to="{name: 'EntryCreate', params: {type: 1, parentId: parentId }}"
          >
            <button class="btn btn-primary">
              <i class="fas fa-plus"></i>
            </button>
          </router-link>
        </div>
        <div v-if="entries != null" class="card-body">
          <div class="text-secondary text-center" v-if="entries.length == 0">
            <br>
            <i class="fas fa-exclamation-circle"></i>
            Өгөгдөл байхгүй байна
          </div>
          <div class="article-card" v-for="(article, i) in this.entries" :key="i">
            <div class="article-card__thumbnail">
              <img class="mh-100 mw-100" v-bind:src="article.contents[0].thumb" alt>
            </div>
            <div class="article-card__details">
              <h5 class="text-uppercase article-card__title">{{ article.contents[0].title }}</h5>
              <p class="size-2 my-2">{{ article.publishDate }}</p>
              <div class="article-card__description">{{ article.contents[0].description }}</div>
            </div>
            <div v-if="!isBannerMgr" class="article-card__actions">
              <router-link
                :to="{name: 'EntryEdit', params: {type: 1, entryId: article.id, parentId: parentId}}"
              >
                <button class="btn btn-info btn-sm">
                  <i class="fas fa-edit"></i>
                </button>
              </router-link>
              <button
                v-if="!article.staticFlag && article.status == 1"
                class="btn btn-warning btn-sm mx-2 status-btn"
                @click="changeStatus(article)"
              >
                <i class="fas fa-times"></i>
              </button>

              <button
                v-if="!article.staticFlag && article.status != 1"
                class="btn btn-success btn-sm mx-2 status-btn"
                @click="changeStatus(article)"
              >
                <i class="fas fa-upload"></i>
              </button>
              <button @click="deleteArticle(article.id)" class="btn btn-danger btn-sm">
                <i class="fas fa-trash"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-dialog/>
  </div>
</template>

<style>
.article-card {
  display: flex;
  justify-content: space-between;
  margin: 1em 0;
}

.article-card__thumbnail {
  width: 20%;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.article-card__details {
  width: 60%;
}

.article-card__title {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-height: 20px;
  max-height: 32px;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.map-url {
  margin-top: -5px;
}

.article-card__description {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-height: 18px;
  max-height: 55px;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>

<script>
import MenuService from "@/services/MenuService";
import DeleteDialog from "@/mixins/DeleteDialog.js";
import EntryList from "@/mixins/EntryList.js";

export default {
  name: "Articles",

  mixins: [DeleteDialog, EntryList],

  props: ["parentId", "entries"],

  methods: {
    deletedHandler(id) {
      let index = this.entries.map(entry => entry.id).indexOf(id);
      if (index > -1) this.entries.splice(index, 1);
    },

    deleteArticle(id) {
      this.confirmDelete(
        id,
        "Мэдээ устгах!",
        "Та энэ мэдээг устгах уу?",
        MenuService.changeStatus,
        this.deletedHandler
      );
    }
  }
};
</script>